import { Component, Injector, Input, OnInit, inject as inject_1, output, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

import { MatToolbarModule } from '@angular/material/toolbar';
//import { JkGlbClass } from '../../services/jkglb';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { jkGlb } from '../../services/jkglb';

/**
 * 首頁頂部標題欄組件
 *
 * 應用程式首頁的頂部標題欄，提供導航、使用者資訊和系統操作等功能。
 * 此組件負責顯示應用程式標題、使用者登入狀態、版本資訊，
 * 並提供選單切換和使用者操作功能。
 */
@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatIcon, MatToolbarModule, MatChipsModule, MatMenuModule, MatDividerModule],
})
export class HomeHeaderComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'home-header';

  /** 左側選單切換事件，當用戶點擊左側選單按鈕時觸發 */
  readonly leftMenuChange = output<boolean>();

  /** 右側選單切換事件，當用戶點擊右側選單按鈕時觸發 */
  readonly rightMenuChange = output<boolean>();

  /*onValueChange(newValue: boolean) {
    //this.showMenu = newValue;
    this.valueChange.emit(newValue);
  }*/

  /** 左側選單按鈕點擊回調 */
  cbLeftMenu?: () => void;

  /** 右側選單按鈕點擊回調 */
  cbRightMenu?: () => void;

  /** 選單項目計數 */
  menuCount: number = 0;

  /** 已添加的選單ID列表 */
  menuList: string[] = [];

  //menuTree = menuTree;

  /** 子選單樹 */
  subMenuTree: any[] = [];
  /**
   * 指派選單項目，用於動態建立選單
   * @param menu 選單項目數組
   * @param title 選單標題
   * @returns 空字串，表示操作完成
   */
  assignMenu(menu: any, title: string): string {
    //console.log(title);
    if (title === 'submenu') {
      console.log('submenu', menu);
    }
    if (Array.isArray(menu) && (menu.length > 0)) {
      this.subMenuTree = [];
      let firstId = '';
      if (menu.length > 0) {
        firstId = menu[0].id;
      };
      let bool = this.menuList.includes(firstId);
      if (bool) {
        return '';
      }

      //let n2 = this.mainMenu._allItems.length;
      //console.log('menu items count:',n2);

      if (this.menuCount > 100)
        return '';
      if (firstId !== '') {
        this.menuList.push(firstId);
      }
      this.subMenuTree.push(...menu);
      let n = this.subMenuTree.length;
      this.menuCount += n;
    }

    return '';
  }
  /**
   * 顯示左側選單
   * 觸發leftMenuChange事件並呼叫cbLeftMenu回調
   */
  doShowLeftMenu() {
    this.leftMenuChange.emit(true);
    if (this.cbLeftMenu) this.cbLeftMenu();
  }

  /**
   * 顯示右側選單
   * 觸發rightMenuChange事件並呼叫cbRightMenu回調
   */
  doShowRightMenu() {
    this.leftMenuChange.emit(true);
    if (this.cbRightMenu) this.cbRightMenu();
  }

  /**
   * 獲取登入狀態文字
   * @returns 登入狀態文字，已登入顯示「🟢已登入」，未登入顯示「❌未登入」
   */
  get loginStatus(): string {
    let s = this.login.isLogin ? '🟢已登入' : '❌未登入';
    return s;
  }
  public router: Router;
  //public home:HomeService;

  /**
   * 獲取當前使用者名稱
   * @returns 使用者名稱
   */
  get username(): string {
    return this.login.name; //this.home.username;
  }

  /**
   * 獲取使用者頭像圖示
   * @returns 頭像圖示名稱
   */
  get avatarIcon(): string {
    return this.login.avatarIcon;
  }
  //public jkGlb: JkGlbClass;
  /**
   * 建構函數
   * @param inject 注入器，用於獲取服務和依賴
   */
  constructor() {
    const inject = inject_1(Injector);

    super();
    this.label.set('首頁');
    //this.jkGlb = inject.get(JkGlbClass);
    this.router = inject.get(Router);
    //this.home = inject.get(HomeService);
    //this.router = home.getRouter();
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  /**
   * 執行登入操作
   * 導航到登入表單頁面
   */
  doLogin() {
    //page.navigateTo('/login-form');
    this.router.navigate(['/sys/login-form']);
  }

  /**
   * 執行登出操作
   * 調用登入服務的登出方法
   */
  logout() {
    this.login.logout(this.login.hostName);
  }

  /**
   * 執行系統更新操作
   * 添加時間戳參數並重新載入頁面
   */
  doUpdate() {
    let url = window.location.host;
    let param = { timestamp: new Date().getTime() };
    //page.navigateTo('/', param);
    this.router.navigate(['/'], { queryParams: param });
    window.location.reload();
  }
  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  _version: string = '';
  /**
   * 獲取系統版本
   * @returns 系統版本號
   */
  get version(): string {
    return this._version || jkGlb.env.version; // TODO: this.jkGlb.env.version;  'home-header 未預設版本'
  }

  /**
   * 顯示關於對話框
   */
  doMyAbout() {
    this.doAbout();
  }

  /**
   * 選單點擊處理
   * @param e 點擊事件
   */
  menuClick(e: any) {
    console.log('menu click', e);
  }
}
